import { render, staticRenderFns } from "./PrivacySettings.vue?vue&type=template&id=031818f7"
import script from "./PrivacySettings.vue?vue&type=script&lang=js"
export * from "./PrivacySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports